/**
 * サインアップページで使用される利用規約とプライバシーポリシーのHTMLを提供する関数
 * @returns {string} 利用規約とプライバシーポリシーのHTML
 */
export function getTermsHTML() {
    /* eslint-disable no-irregular-whitespace */
    return `
            <article>
                <h1>利用規約について</h1>
                <p>
                    この利用規約（以下「利用規約」）は、株式会社富士山マガジンサービス（以下「当社」）の運営する、渡邊雄太ファンコミュニティ 「Locker Room」（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。以下「本サービス」という。）のお客様（以下「お客様」）が、<br>
                    本サービスの利用に際して遵守すべき事項を定めたものです。<br>
                    お客様が本サービスを利用した場合、そのお客様は利用規約に同意したものとみなします。<br>
                    なお、別紙「プライバシーポリシー」に記載された全ての内容は、利用規約と一体のものとして、お客様はその内容に同意したものとみなします。<br>
                </p>
                <section>
                    <h2>定義等について</h2>
                    <ol>
                        <li>本サービス上で有料又は無料で提供、アップロードされる記事、動画、音楽、画像、写真、イベント等を「コンテンツ」といいます。</li>
                        <li>本サービスについて、アカウント取得のため所定の登録手続を行い有料購読することを「Locker Room登録」といいます。</li>
                        <li>お客様のうち、Locker Room登録を行ったうえで本サービスを利用する方を「会員」といいます。</li>
                        <li>「利用環境」とは、本サービスの提供を受けるために契約者が設置するコンピュータ、電気通信設備その他の機器及びソフトウェアを総称していいます。</li>
                        <li>「AWS」とは、Amazon Web Services, Inc.の提供するサービスをいいます。</li>
                        <li>「Stripe」とは、ストライプジャパン株式会社の提供するサービスをいいます。</li>
                        <li>「Mailgun」とは、Mailgun Technologies, Inc.の提供するサービスをいいます。</li>
                        <li>「AWS各種規約」とは、Amazon Web Services, Inc.が規定する以下のAWSのサービスの各種規約をいいます。</li>
                    </ol>
                </section>
                <section>
                    <h2>Locker Room 登録について</h2>
                    <ol>
                        <li>
                        Locker Room登録を希望するお客様は（以下「登録希望者」）は、利用規約を遵守することに同意し、かつ当社の定める一定の情報（以下「登録情報」といいます。）を当社の定める方法で当社に提供することにより、当社に対し、本サービスの利用の登録を申請することができます。
                        </li>
                        <li>
                        登録の申請は必ず本サービスを利用する個人又は法人自身が行わなければならず、原則として代理人による登録申請は認められません。また、登録希望者は、登録の申請にあたり、真実、正確かつ最新の情報を当社に提供しなければなりません。
                        </li>
                        <li>
                        当社は、第1項に基づき登録を申請した者が、以下の各号のいずれかの事由に該当する場合は、登録を拒否することがあります。
                        </li>
                        <li>
                        当社は、前項その他当社の基準に従って、登録希望者の登録の可否を判断し、当社が登録を認める場合にはその旨を登録希望者に通知します。かかる通知により登録希望者のお客様としての登録は完了し、利用規約の諸規定に従った本サービスの利用にかかる契約（以下「利用契約」）がお客様と当社の間に成立します。
                        </li>
                        <li>
                        会員は、登録情報に変更があった場合は、遅滞なく、当社の定める方法により、当該変更事項を当社に通知し、当社から要求された資料を提出するものとします。
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>未成年者の利用について</h2>
                    <ol>
                        <li>
                        未成年者のお客様が、親権者等の同意がないにもかかわらず、それを偽り本サービスを利用した場合、本サービスに関する一切の法律行為（コンテンツの投稿等による当社への利用権の付与等を含みます。）を取り消すことはできません。
                        </li>
                        <li>
                        この利用規約の同意時に未成年者であったお客様が成年に達した後に本サービスを利用した場合、当該お客様は本サービスに関する一切の法律行為を追認したものとみなします。
                        </li>
                        <li>
                        当社は、お客様に対するコンテンツの提供にあたり、未成年者のお客様がいることを踏まえて、必要と思われるゾーニングや注意喚起等に努めますが、親権者等の同意と適切な監督によらずに未成年者が本サービスを利用した場合に、その利用の結果について当社に故意又は重過失がある場合を除き、一切の責任を負いません。
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>本サービスの内容について</h2>
                    <ol>
                        <li>
                        本サービスの具体的内容については、本サービス上に随時掲載するものとし、お客様が本サービスを利用する際には、該当する掲載部分の記載に従うものとします。
                        </li>
                        <li>
                        当社は、法律上の請求原因の如何を問わず、いかなる場合においても当該情報の利用に関して生じたお客様に係る損害、損失、費用ならびに不利益等に関し、当社に故意又は重過失がある場合を除き、一切責任を負わないものとします。
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>有料購読の価格について</h2>
                    <ol>
                        <li>
                        有料購読の期間の計算は、会員がLocker Room登録の申し込みをし、決済が完了した日を第１日目（以下、「利用開始日」といいます）とし、以降、支払いを行った分の期間まで、本サービスを利用できるものとします。
                        </li>
                        <li>
                        利用開始日から1か月以内に会員が有料購読を中止した場合には、1か月分の購読料の支払い義務を負います。また、1か月を超えて利用した場合には、利用開始日の翌月以降の応当日までの利用分につき購読料が発生します。有料購読中止日が応当日前であっても、当該月分の購読料は発生します。なお、有料購読中止日の翌日以降は利用ができなくなります。
                        </li>
                        <li>
                        クレジットカード決済の詳細はStripe利用規約にてご確認ください。
                        </li>
                        <li>
                        お客様が本サービスを利用する場合、本サービスの対価として、本サービス上の購入申込み画面において表示される金額を、クレジットカード決済など当社が定める決済方法のうち、お客様が選択した方法により、当社が課金し徴収することに同意します。
                        </li>
                        <li>
                        本サービスで表示している価格は、全て税込み価格です。
                        </li>
                        <li>
                        今後、経済情勢の変動、消費税の税率変更等の事由に基づき、当社は代金を改定することができるものとします。
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>返品・交換について</h2>
                    <p>コンテンツについては商品の特性上、返品や返金、交換は承っておりません。</p>
                </section>
                <section>
                    <h2>プライバシーポリシーについて</h2>
                    <p>
                        本サービスをご利用いただくに際して、お客様より登録いただいた個人情報の取得主体は当社となります。
                        当社は、その個人情報の取扱いに関しては、別途定める「プライバシーポリシー 」に従うものとし、お客様はこれに同意するものとします。
                    </p>
                </section>
                <section>
                    <h2>知的財産権について</h2>
                    <ol>
                        <li>
                        当社が掲載した、本サイト上のデータの知的財産権は全て株式会社 Office YBに帰属します。お客様は、本サービスで株式会社 Office YBが提供する文章、画像、デザイン等あらゆる形の情報の一部又は全部を、利用許諾で認められた範囲を超えて使用をすることはできません。また、お客様は、他のお客様その他の第三者が知的財産権を所有しているコンテンツを、必要な許諾を得ずに、投稿してはなりません。
                        </li>
                        <li>お客様が本サービス上に投稿又は共有したコンテンツに関する知的財産権はお客様自身に帰属するものとします。</li>
                        <li>お客様は、本サービスを通じて提供、投稿、又は共有したコンテンツに対して、当社に対する非独占的な知的財産権の利用許諾を行うものとします。この利用許諾により、当社は、本サービスの運営、宣伝、改善、又は派生サービスの提供に必要な範囲内で当該コンテンツを利用できるものとし、本サービス以外の外部での利用は行わないものとします。</li>
                        <li>利用規約で別途定める場合を除き、お客様が自身のコンテンツを削除した場合、本サービス上からそのコンテンツが削除されるものとします。ただし、既に他のお客様によってコンテンツが共有又は引用された場合、当該コンテンツは当然には削除されないことについて、予め認識し、ご了承下さい。</li>
                        <li>お客様が本サービス上に投稿したコンテンツは、個人的、非商業的な目的や商業的な目的で他のお客様によって利用されることがあるものとします。</li>
                        <li>本サービスを退会することにより、お客様は投稿したコンテンツから生じる報酬を得る権利を失うものとします。退会後、コンテンツが商業的に利用されても、元のお客様には報酬が支払われないものとします。</li>
                        <li>
                        お客様が本サービス上に投稿したコメント等のコンテンツは、その特性上訂正・削除することができないものとします。これは、コミュニティ全体の知識共有と情報の永続性を確保するためのものです。<br>
                        ただし、著作権侵害、プライバシー侵害、名誉毀損等の法的問題が発生した場合、権利侵害を受けた者は、以下の情報を明記の上、「お問い合わせ」にて申立てを行うことができるものとします。<br>
                        (1) 住所、氏名、連絡先<br>
                        (2) 侵害情報に関する詳細<br>
                        (3) 侵害されたとする権利とその理由
                        </li>
                        <li>お客様が利用規約の各規定に違反して生じた問題については、当社は、当社に故意又は重過失がある場合を除き、何ら責任を負わないものとし、お客様が自己の責任において問題を解決するものとします。</li>
                    </ol>
                </section>
                <section>
                    <h2>投稿について</h2>
                    <ol>
                        <li>本サービスにおける投稿に関する責任は、お客様自身が負うものとします。</li>
                        <li>
                        当社は、お客様が、本サービスにおいて投稿したコンテンツに関して、その正確性・速報性・合法性・完全性・有用性等を含む内容においていかなる保証もいたしません。
                        したがって、当社は、当社に故意又は重過失がある場合を除き、お客様に代わっての責任は負いかねます。
                        投稿の内容については、お客様自身のご判断でご利用ください。
                        投稿（リンクされた外部サイトを含みます）によって生じた損害（名誉、信用の毀損、及びコンピューターウィルス感染被害などによる損害も含みます）や
                        お客様同士のトラブル等に対し、当社に故意又は重過失がある場合を除き、当社は一切の補償・関与をいたしません。
                        </li>
                        <li>
                        お客様が以下に該当すると当社が判断した場合、お客様に事前に通知することなく当社はお客様のご利用を停止させて頂き、コンテンツを削除、又は検索結果からの除外などの措置をすることがあります。
                        かかる利用の停止又はコンテンツの削除等によりお客様に損害が生じた場合であっても、
                        当社は、当社に故意又は重過失がある場合を除き、損害賠償責任その他一切の責任を負わないものとします。
                        </li>
                        <li>
                        お客様が本サービスを退会された後も下記コンテンツは削除されないものとします。<br>
                        ・お客様が投稿された記事・コメント
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>本サービスについて</h2>
                    <p>
                        当社は事前の通知なく本サービスの運営の諸条件、サービス内容の変更ができるものとします。
                        また、当社は営業上、技術上の理由等により、本サービスを終了することができるものとします。
                        その際、当社に故意又は重過失がある場合を除き、お客様が本サービスをご利用になれなかった事により発生した、
                        いかなる損害・損失・不利益に関して責任を負わないものとします。
                    </p>
                </section>
                <section>
                    <h2>サービスの変更・停止・終了について</h2>
                    <ol>
                        <li>
                        当社は、当社が必要と判断する場合、あらかじめお客様に通知することなく、いつでも、本サービスの全部または一部の内容を変更し、また、その提供を中止することができます。
                        </li>
                        <li>
                        当社は、次のいずれかの事由が生じた場合、本サービスの全部または一部の提供を一時中断し、または停止することがあります。<br>
                        (1) 本サービスの提供に必要なネットワークシステムその他の設備の保守点検等を定期的または緊急に行う場合<br>
                        (2) 本サービスの提供に必要な設備に故障等が生じた場合<br>
                        (3) 停電、火災、地震その他不可抗力により本サービスを提供することが困難になった場合<br>
                        (4) 外部システムに生じた事由によって本サービスの提供が困難になった場合<br>
                        (5) その他、本サービスを提供することができない合理的な理由が生じた場合
                        </li>
                        <li>
                        当社は、前項に基づく本サービスの変更、中止、一時中止または一時停止に関して、当社の故意または重過失による債務不履行または不法行為に基づく場合を除き、お客様または第三者に対し、いかなる責任も負わないものとします。
                        </li>
                        <li>
                        当社は、当社の都合により、お客様に事前に通知した後、本サービスの全部または一部の提供を終了することができるものとします。<br>
                        (1) 会員への通知は、本サービス上での掲載およびその他の合理的な方法によって行われるものとします。<br>
                        (2) 当社は、本サービスの終了によってお客様が何らかの損害を被ったとしても、何らの責任も負わないものとします。
                        </li>
                        <li>
                        当社はシステムの稼動状態を良好に保つため、又はその他やむをえない事情が発生した場合、お客様に事前の通知なく、本サービスの内容の変更、全部又は一部サービスの停止をすることができるものとします。
                        その際、当社に故意又は重過失がある場合を除き、お客様が本サービスをご利用になれなかった事により発生した、いかなる損害・損失・不利益に関して責任を負わないものとします。
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>アカウント情報の管理について</h2>
                    <ol>
                        <li>会員ID及びメールアドレス（以下「アカウント情報」といいます。）は、お客様がLocker Room登録後に付与されます。</li>
                        <li>会員は、自己の責任において、登録をした本サービスにかかるアカウント情報を管理および保管するものとし、これを第三者に利用させたり、貸与、譲渡、名義変更、売買等してはなりません。</li>
                        <li>アカウント情報の管理の不十分、使用上の過誤、第三者の使用等による損害の責任は会員が負うものとし、当社は一切の責任を負いません。</li>
                        <li>会員は、アカウント情報が盗まれ、または第三者に使用されていることが判明した場合には、直ちにその旨を当社に通知するとともに、当社の指示に従うものとします。</li>
                        <li>会員は、当社の指定する方法によりIDを変更することができます。なお、当社は、本サービスの運営において必要が生じた場合、会員に通知のうえ、会員のIDを変更することがあります。</li>
                    </ol>
                </section>
                <section>
                    <h2>設備の負担等</h2>
                    <ol>
                        <li>本サービスの提供を受けるために必要な、コンピューター、スマートフォン、ソフトウェアその他の機器、通信回線その他の通信環境等の準備及び維持は、お客様の費用と責任において行うものとします。</li>
                        <li>お客様は自己の本サービスの利用環境に応じて、コンピューター・ウィルスの感染の防止、不正アクセス及び情報漏洩の防止等のセキュリティ対策を自らの費用と責任において講じるものとします。</li>
                        <li>当社は、お客様が送受信したメッセージその他の情報を運営上一定期間保存していた場合であっても、かかる情報を保存する義務を負うものではなく、当社はいつでもこれらの情報を削除できるものとします。</li>
                        <li>お客様は、本サービスの利用開始に際し又は本サービスの利用中に、本サイトからのダウンロードその他の方法によりソフトウェア等をお客様のコンピューター、スマートフォン等にインストールする場合には、お客様が保有する情報の消滅若しくは改変又は機器の故障、損傷等が生じないよう十分な注意を払うものとします。</li>
                        <li>本サービスの提供を受けるために必要な、コンピューター、スマートフォン、ソフトウェアその他の機器、通信回線その他の通信環境等の準備及び維持は、お客様の費用と責任において行うものとします。</li>
                        <li>お客様は自己の本サービスの利用環境に応じて、コンピューター・ウィルスの感染の防止、不正アクセス及び情報漏洩の防止等のセキュリティ対策を自らの費用と責任において講じるものとします。</li>
                        <li>当社は、お客様が送受信したメッセージその他の情報を運営上一定期間保存していた場合であっても、かかる情報を保存する義務を負うものではなく、当社はいつでもこれらの情報を削除できるものとします。</li>
                        <li>お客様は、本サービスの利用開始に際し又は本サービスの利用中に、本サイトからのダウンロードその他の方法によりソフトウェア等をお客様のコンピューター、スマートフォン等にインストールする場合には、お客様が保有する情報の消滅若しくは改変又は機器の故障、損傷等が生じないよう十分な注意を払うものとします。</li>
                    </ol>
                </section>
                <section>
                    <h2>禁止事項について</h2>
                    <h3>1. お客様は、本サービスの利用にあたり、以下の各号のいずれかに該当する行為をしてはなりません。</h3>
                    <ol>
                        <li>当社、情報提供元、権利保持者、販売提携会社、広告主など第三者の著作権、商標権等の知的財産権、その他の権利又は利益を侵害する行為、又は侵害するおそれのある行為。</li>
                        <li>当社、他のお客様、お客様その他の第三者の財産、プライバシーもしくは肖像権を侵害する行為、又は侵害するおそれのある行為。</li>
                        <li>当社、他のお客様、お客様その他の第三者を差別もしくは誹謗中傷し、又は名誉もしくは信用を毀損する行為。</li>
                        <li>他者に精神的もしくは経済的損害を与える行為、又は与えるおそれのある行為。</li>
                        <li>面識のない異性との猥褻目的での出会いを主な目的として利用する行為。</li>
                        <li>未成年者を害する行為、又は害するおそれのある行為。</li>
                        <li>詐欺、規制薬物の濫用、児童売買春、預貯金口座及び携帯電話の違法な売買等の犯罪に結びつく、又は結びつくおそれの高い行為。</li>
                        <li>わいせつ、児童ポルノ若しくは児童虐待に相当する画像、映像、音声若しくは文書等を送信又は表示する行為、又はこれらを収録した媒体を販売する行為、又はその送信、表示、販売を想起させる広告を表示又は送信する行為。</li>
                        <li>無限連鎖講（ネズミ講）を開設し、又はこれを勧誘する行為。</li>
                        <li>特定の宗教団体や宗教活動の勧誘行為。</li>
                        <li>自分以外の人物もしくは組織になりすます行為。</li>
                        <li>本サービスの利用もしくは運営に支障を与える行為（与えるおそれのある行為を含む）。</li>
                        <li>他者の設備等又はインターネット接続サービス用設備の利用若しくは運営に支障を与える行為、又は与えるおそれのある行為。</li>
                        <li>金融商品取引業に該当する行為（詳細は金融商品取引法に準拠）。</li>
                        <li>違法な賭博・ギャンブルを行わせ、又は参加を勧誘する行為。</li>
                        <li>けん銃等の譲渡、爆発物の製造、児童ポルノの提供、公文書偽造、殺人、脅迫等の違法行為を請負・仲介・誘引する行為。</li>
                        <li>嫌悪感を抱かせる勧誘や広告、宣伝の掲載。</li>
                        <li>自殺に誘引・勧誘する行為や危害の及ぶ手段の紹介。</li>
                        <li>誹謗中傷やプライバシー侵害を含む情報の助長行為。</li>
                        <li>法令違反、運営妨害、内部規則違反、第三者の信用・財産の侵害、または不利益行為。</li>
                        <li>本サービスで得られる情報の改ざん等。</li>
                        <li>当社の許可なく営利活動やその準備行為。</li>
                        <li>社会通念上他者に嫌悪感を抱かせる情報の掲載。</li>
                        <li>個人情報の収集・蓄積やストーキング行為。</li>
                        <li>上記行為を助長するための外部リンク設置やアクセス。</li>
                        <li>アカウントの譲渡・貸与行為。</li>
                        <li>その他、当社が不適切と合理的に判断する行為。</li>
                    </ol>
                    <h3>2. 違反時の措置</h3>
                    <p>
                        当社は、本サービスにおけるお客様による投稿、その他の情報の送信が前項各号のいずれかに該当し、
                        又は該当するおそれがあると当社が合理的に判断した場合には、
                        お客様に事前に通知することなく、当該情報の全部又は一部について削除、送信停止その他の措置をとることができるものとします。
                        当社は、本項に基づき当社が行った措置によりお客様に生じた損害について、
                        当社の故意又は重過失による場合を除き、一切の責任を負いません。
                    </p>
                </section>
                <section>
                    <h2>登録取消について</h2>
                    <ol>
                        <li>当社は、会員が、以下の各号のいずれかの事由に該当する場合は、事前に通知又は催告することなく、当該会員について本サービスの利用を一時的に停止し、又は会員としての登録を取り消すことができます。</li>
                        <li>（1）利用規約のいずれかの条項に違反した場合</li>
                        <li>（2）登録情報に虚偽の事実があることが判明した場合</li>
                        <li>（3）当社、会員、他の会員その他の第三者に損害を生じさせるおそれのある目的又は方法で本サービスを利用した、又は利用しようとした場合</li>
                        <li>（4）手段の如何を問わず、本サービスの運営を妨害した場合</li>
                        <li>（5）支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合</li>
                        <li>（6）自ら振出し、若しくは引受けた手形若しくは小切手につき、不渡りの処分を受けた場合、又は手形交換所の取引停止処分その他これに類する措置を受けたとき</li>
                        <li>（7）差押、仮差押、仮処分、強制執行又は競売の申立てがあった場合</li>
                        <li>（8）租税公課の滞納処分を受けた場合</li>
                        <li>（9）死亡した場合</li>
                        <li>（10）「登録について」第3項各号に該当する場合</li>
                        <li>（11）その他、当社が会員としての登録の継続を適当でないと合理的に判断した場合</li>
                        <li>前項各号のいずれかの事由に該当した場合、会員は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。</li>
                        <li>会員は、当社所定の方法で相手方に通知することにより、会員の登録を取り消すことができます。</li>
                        <li>当社は、本条に基づき当社が行った行為により会員に生じた損害について、当社の故意又は重過失による場合を除き、一切の責任を負いません。</li>
                        <li>本条に基づき会員の登録が取り消された場合、会員は、当社の指示に基づき、当社から提供を受けた本サービスに関連するソフトウェア、マニュアルその他の物につき、返還、廃棄その他の処分を行うものとします。</li>
                    </ol>
                </section>
                <section>
                    <h2>反社会的勢力の排除について</h2>
                    <ol>
                        <li>
                        当社は、会員又は利用契約締結に関する会員の代理  人若しくは利用契約締結を媒介した者が反社会的勢力等であることが判明した場合には、
                        会員に対し、利用契約の解除その他の必要な措置を講ずるよう求めることができるものとします。
                        </li>
                        <li>
                        前項に基づいて必要な措置を講ずるよう求めたにもかかわらず、会員が正当な理由なくこれを拒否した場合、
                        当社は催告を要せず会員に書面で通知することにより直ちに会員の登録を取り消すことができるものとします。
                        </li>
                        <li>
                        前各項に定める場合を除き、当社は、会員の取締役、監査役、従業員その他の構成員、株主、取引先、若しくは顧問その他のアドバイザーが反社会的勢力等であること、
                        又は会員が資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていることが判明した場合において、
                        その解消を求める通知を会員が受領後相当期間内にこれが解消されないときは、会員に電子メール又は書面で通知することにより直ちに会員の登録を取り消すことができるものとします。
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>会員の退会</h2>
                    <ol>
                        <li>
                        会員が退会を希望する場合には、当社所定の手続を経ることにより退会を行えるものとします。
                        </li>
                        <li>
                        当社は、会員について、「禁止事項について」第1項所定のいずれかに該当する事由が明らかとなった場合は、
                        当社の判断によって、会員を強制的に退会させ、本サービスの利用をお断りすることがあります。
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>免責について</h2>
                    <ol>
                        <li>
                        当社は、お客様が本サービスの利用により被った損害に関して、当社に故意又は重過失がある場合を除き、責任を負わないものとします。
                        また、お客様が本サービスの利用により、お客様、他のお客様その他の第三者に対して損害等を与えた場合には、
                        当該お客様は自己の責任において解決し、当社には一切責任を負わないものとします。
                        </li>
                        <li>
                        消費者契約法その他の強行法規の適用その他何らかの理由により、当社が本サービスに関してお客様に対して損害賠償責任を負う場合においても、
                        当社の故意又は重過失による場合を除き、当社の賠償責任は、直接かつ通常の損害に限り、
                        逸失利益、間接損害等は含まないものとし、
                        また、損害の事由が生じた時点から遡って過去1ヶ月間にお客様から現実に受領した本サービスの対価の総額又は500円のいずれか高い金額を上限とします。
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>メールによる通知について</h2>
                    <ol>
                        <li>
                        当社から会員に対する通知及びご連絡は、会員からのお申し込みの完了後に発送する「お申し込み完了通知」を含め、
                        当社から特に他の方法を指定しない限り、すべてメールを会員の登録したメールアドレス宛に発信することによって行うことができるものとします。
                        </li>
                        <li>
                        当社が、会員が登録したメールアドレス宛にメールでご通知・ご連絡を発信したにもかかわらず、
                        当社側の過失なくしてこれが会員に届かなかったことによりお客様が損害・損失・不利益等（損害等）を被ったとしても、
                        当社はその損害等につき一切の責任を負わないものとします。
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>外部システムの利用</h2>
                    <ol>
                        <li>
                        当社は、以下の外部システムを利用して本サービスをお客様に提供しています。<br>
                        (1) AWS<br>
                        (2) Stripe<br>
                        (3) Mailgun<br>
                        </li>
                        <li>
                        お客様は、本サービスの利用にあたり、AWS各種規約、Stripe各種規約、Mailgun各種規約の適用を受けることを承諾します。
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>協議による解決について</h2>
                    <p>
                        本サービスのご利用に関して、利用規約又は当社の指導により解決できない問題が生じた場合には、
                        当社と当該お客様との間で双方誠意を持って話し合い、解決するものとします。
                    </p>
                </section>
                <section>
                    <h2>準拠法と合意管轄裁判所について</h2>
                    <ol>
                        <li>本利用規約は、日本法を準拠法とします。</li>
                        <li>本利用規約の各事項に関連して紛争が生じた場合は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
                    </ol>
                </section>
                <section>
                    <h2>利用規約の変更について</h2>
                    <ol>
                        <li>
                        当社は、お客様に対する事前の通知をすることなく利用規約、及び、別紙「プライバシーポリシー」に記載された全ての内容（利用規約等）を変更することがあります。
                        </li>
                        <li>
                        当社は、利用規約等を変更する場合には、変更の内容及び変更の効力発生時期を、当該効力発生時期までに当社所定の方法で告知するものとします。
                        告知された効力発生時期以降にお客様が本サービスを利用した場合には、お客様は、利用規約等の変更に同意したものとみなします。
                        </li>
                        <li>
                        最新の内容変更を本サイトで頻繁にご確認頂けますようお願致します。別途規定されていない限り、最新の利用規約がお客様の現在の全てのお取引に適用されます。
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>利用規約の譲渡等</h2>
                    <ol>
                        <li>
                        お客様は、当社の書面による事前の承諾なく、利用契約上の地位又は利用規約に基づく権利若しくは義務につき、
                        第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。
                        </li>
                        <li>
                        当社は本サービスにかかる事業を第三者に譲渡（事業譲渡、会社分割その他態様の如何を問わないものとします。）した場合には、
                        当該譲渡に伴い利用契約上の地位、利用規約に基づく権利及び義務並びにお客様の登録情報その他の顧客情報を
                        当該譲渡の譲受人に譲渡することができるものとし、お客様は、かかる譲渡につき本項において予め同意したものとします。
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>お問い合わせ</h2>
                    <p>
                        当社の利用規約に関するご質問は「お問い合わせ」までお願いいたします。
                    </p>
                </section>
            </article>
            <article>
                <h1>プライバシーポリシー</h1>
                <p>株式会社富士山マガジンサービスは、プライバシーマークを取得しています。</p>
                <p>
                    当社の主事業である雑誌定期購読販売事業を行っていく上で、「個人情報保護」は重要なテーマです。また、「個人情報（以下、個人情報の保護の関する法律第2条に定義する個人情報を意味する）」は、お客様にとっても、取り扱う当社にとっても重要な情報資産であり、確実に保護することは重要な責務であります。
                    したがって、当社は「個人情報保護」のための全社的な取り組みを実施し、お客様への「安心」の提供及び社会的責任の責務を果たすことを確実にいたします。
                </p>
            <section>
                <h2>個人情報の取得・利用・提供について</h2>
                <p>
                    当社は、個人情報の取得・利用・提供に際して、その利用目的を明確にし、本人の同意を得たうえで利用目的の達成に必要な範囲内で適法かつ公正な手段によって取得・利用・提供を行います。また、当社が保有している個人情報は、同意を得ずに目的外利用、第三者への提供・開示は行いません。当社においてはこれらの取り組みを確実にするため、従業者等の教育を徹底してまいります。また、目的外利用を行わないために、適切な管理措置を講じます。
                </p>
            </section>
            <section>
                <h2>法令遵守</h2>
                <p>
                    当社は、個人情報に関連する法令、国が定める指針及びその他の規範を遵守します。また、当社の管理の仕組みに、これらの法令及びその他の規範を常に適合させます。
                </p>
            </section>
            <section>
                <h2>個人情報の安全管理措置</h2>
                <p>
                    当社は、個人情報の正確性及び安全性を確保するために、下記セキュリティ対策をはじめとする安全対策を実施し、
                    個人情報の漏えい、滅失またはき損の防止及び是正に努めます。
                </p>
                <ul>
                    <li><strong>アクセス制御：</strong>個人データを取り扱うことのできる機器及び当該機器を取り扱う従業者を明確化し、個人データへの不要なアクセスを防止しています。</li>
                    <li><strong>アクセス者の識別と認証：</strong>機器に標準装備されているユーザー制御機能（ユーザーアカウント制御）により、個人情報データベース等を取り扱う情報システムを使用する従業者を識別・認証しています。
                    </li>
                    <li><strong>外部からの不正アクセス等の防止：</strong>個人データを取り扱う機器等のオペレーティングシステムを最新の状態に保持しています。また、セキュリティ対策ソフトウェア等を導入し、自動更新機能等の活用により、これを最新状態としています。
                    </li>
                    <li><strong>情報システムの使用に伴う漏洩等の防止：</strong>メール等により個人データの含まれるファイルを送信する場合に、当該ファイルへのパスワードを設定しています。</li>
                </ul>
            </section>
            <section>
                <h2>個人情報保護マネジメントシステムの継続的改善</h2>
                <p>
                    当社は、内部監査及びマネジメントレビューの機会を通じて、
                    個人情報保護マネジメントシステムを継続的に改善し、常に最良の状態を維持します。
                </p>
            </section>
            <section>
                <h2>苦情及び相談受付け窓口</h2>
                <p>
                    貴殿の個人情報及び当社の個人情報保護マネジメントシステムに関するご相談及び苦情については以下までご連絡ください。
                    適切、かつ迅速に対応させていただきます。
                </p>
                <ul>
                    <li>株式会社富士山マガジンサービス 個人情報問い合わせ係</li>
                    <li>TEL：0570-200-223</li>
                    <li>FAX：03-5459-7073</li>
                    <li>e-mail：cs@fujisan.co.jp</li>
                    <li>制定：2024年10月1日</li>
                    <li>株式会社富士山マガジンサービス 代表取締役会長 西野伸一郎</li>
                </ul>
            </section>
            <section>
                <h2>個人情報の取扱いについて</h2>
                <h3>1. 個人情報保護管理者</h3>
                <p>
                    当社は以下の個人情報保護管理者を設置し、個人情報保護管理者の責任のもと、個人情報を取得・アクセス・利用・提供・管理いたします。
                </p>
                <address>
                    東京都渋谷区南平台町16-11<br />
                    株式会社富士山マガジンサービス<br />
                    代表取締役会長　西野 伸一郎<br />
                    個人情報保護管理者: 経営管理グループディレクター 前田 嘉也
                </address>

                <h3>2. 利用目的</h3>
                <p>当社が取り扱う開示対象個人情報の利用目的は次のとおりです。</p>
                <table border="1">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>個人情報の種類</th>
                            <th>利用目的</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>当社の定期購読サービス等をご利用の方の個人情報</td>
                            <td>
                                購入商品の配送のため<br />
                                商品代金回収のため<br />
                                ｅメール等による商品、サービス、キャンペーン等の広告の案内のため<br />
                                個人が特定できない形で取得した閲覧履歴や購買履歴等の情報を分析して、趣味・嗜好に応じた新商品・サービスに関する広告のため
                            </td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>当社にお問合わせいただいた方の個人情報</td>
                            <td>お問い合わせ対応、トラブル対処、オペレーター教育など応対品質向上のため</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>当社カスタマーQ＆Aサービス利用者</td>
                            <td>
                                カスタマーQ＆Aサイトの投稿内容の確認のため<br />
                                ｅメール等によるカスタマーQ＆Aサイトのサービス内容のご案内のため<br />
                                ｅメール等による商品、サービス、キャンペーン等の広告に関するご案内のため
                            </td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>採用応募者の方の個人情報</td>
                            <td>採用選考、ご連絡のため</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>当社の従業者の個人情報</td>
                            <td>人事、総務などの雇用管理等のため</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>パートナー（提携企業）からの委託により当社の定期購読サービス等をご利用の方の個人情報</td>
                            <td>
                                購入商品配送のため<br />
                                提携企業及びお客様がご購入された商品の発売元企業からのｅメール等による商品、サービス、キャンペーン等の広告に関するご案内のため
                            </td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>SNS公式アカウントに登録された方の個人情報</td>
                            <td>
                                当社のサービス利用状況の把握およびその分析のため<br />
                                お問い合わせ対応、トラブル対処、オペレーター教育など応対品質向上のため<br />
                                その他当社のプライバシーポリシー等にて公表する利用目的達成のため
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    ※上記の利用目的のうちNo.1～5については保有個人データ（開示対象個人情報）の利用目的であり、下記4.の開示等のご請求に対応させていただきます。<br />
                    なお、6、7については、パートナー（提携企業）様又は各SNS運営会社様にご請求いただきますようお願い致します。
                </p>
                <h3>3. 個人情報の第三者提供について</h3>
                <p>
                    当社は、取得した個人情報を適切に管理し､あらかじめ本人の同意を得ることなく第三者に提供することはありません。ただし、次の場合は除きます。
                </p>
                <ul>
                    <li>法令に基づく場合</li>
                    <li>人の生命､身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき。</li>
                    <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難である場合。</li>
                    <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき。</li>
                    <li>上記２．の利用目的を実施するために守秘義務を結んだ企業に、業務の一部として個人情報の取扱いを委託・提供する場合、その業務に必要な範囲で委託・提供先企業に個人情報を開示することがあります。</li>
                </ul>
                <p>委託・提供先企業は具体的には以下のような企業ですが、これらに限りません。</p>
                <ul>
                    <li>委託先：カスタマーサポート支援会社 、クレジットカード決済などの決済代行・料金回収会社、広告配信サービス会社</li>
                    <li>提供先：出版社、出版物発売元、卸売会社、販売店など商品の供給者、梱包会社、配送会社、新聞販売店などの梱包・配送・配達会社</li>
                </ul>

                <h3>4. 開示対象個人情報の「開示」「訂正」等の請求について</h3>
                <p>
                    当社は、本人から、開示対象個人情報について利用目的の通知を求められた場合には、遅滞なくこれに応じます。ただし、以下①～④のいずれかに該当する場合は、利用目的の通知を行なうことはできません。そのときは、本人に遅滞無くその旨を通知するとともに、理由を説明させていただきます。
                </p>
                <ul>
                    <li>① 利用目的を本人に通知し、又は公表することによって本人又は第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
                    <li>② 利用目的を本人に通知し、又は公表することによって当該事業者の権利又は正当な利益を害するおそれがある場合</li>
                    <li>③ 国の機関又は地方公共団体が法令の定める事務を遂行することに対して協力する必要がある場合であって、利用目的を本人に通知し、又は公表することによって当該事務の遂行に支障を及ぼすおそれがあるとき</li>
                    <li>④ 開示対象個人情報の利用目的が明らかな場合</li>
                </ul>
                <p>
                    開示対象個人情報については、保有個人データの本人またはその代理人からの利用目的の通知、開示、変更等（内容の訂正、追加または削除）、利用停止等（「利用の停止または消去」「第三者への提供の停止」）の求めに対応させていただいております。<br />
                    当社顧客の皆様の個人情報は「マイページ」にログインしていただくことで、訂正、追加、変更を行っていただくことが出来ます。マイページをご利用いただけない方、その他の方につきましては、下記Aをご覧ください。<br />
                    また、ご登録いただいた個人情報のうち、市町村などの名称および郵便番号、金融機関の名称あるいはクレジットカードの有効期限など、商品のお届けやご請求を行う上で支障がある情報に変更があった場合には、当社が登録情報を変更させていただく場合があります。
                </p>

                <h4>A. 開示等の求めの申し出先、提出していただく書面等</h4>
                <p>
                    開示等の求めは、電話又は電子メールにて下記までお申し付けください。開示等の求めに際して提出していただく書面等については、その際にご案内いたします。
                </p>
                <ul>
                    <li>■電話による場合 TEL:0570-200-223 株式会社富士山マガジンサービス 個人情報問い合わせ係 受付時間：10:00～17:00（土、日、祝、年末年始休業）</li>
                    <li>■電子メールによる場合 e-mail：cs@fujisan.co.jp</li>
                </ul>

                <h4>B. 本人確認手続き</h4>
                <p>開示等の対応に際して、以下記載の項目のうち2項目以上での本人確認を実施させていただきます。</p>
                <ul>
                    <li>商品を購入された個人のお客様：氏名、住所、電話番号、顧客番号、メールアドレス</li>
                    <li>商品を購入された法人のお客様：氏名、会社名、部署名、会社住所、電話番号、顧客番号、メールアドレス</li>
                    <li>採用に応募された方：氏名、住所、所属学校（会社）名</li>
                    <li>お取引先様：会社名、部署名、氏名、住所</li>
                    <li>株主様：氏名、住所、（会社名）</li>
                </ul>

                <h4>C. 代理人様による開示等のご請求</h4>
                <p>開示等のご請求をすることについて代理人に委任する場合は、前項の書類に加えて、下記書類をご同封ください。</p>
                <ul>
                    <li>委任状：ご本人様が委任状に捺印し、捺印した印鑑の印鑑登録証明書を添付してください。</li>
                    <li>法定代理人の場合：戸籍謄本もしくは抄本、または住民票をご提出いただくことも可能です。</li>
                    <li>代理人本人であることを確認するための書類（いずれか）：
                        <ul>
                            <li>運転免許証の写し（本籍地を塗りつぶしたもの）</li>
                            <li>住民票の写し</li>
                            <li>健康保険証の被保険者証の写し</li>
                        </ul>
                    </li>
                </ul>

                <h4>D. 手数料について</h4>
                <ul>
                    <li>利用目的の通知、開示対象個人情報の開示請求については、1回の申請ごとに手数料、郵送料が必要です。</li>
                    <li>郵送料：860円（内訳：定形110円、書留480円、本人限定受取郵便270円）※2024年10月1日現在</li>
                    <li>国外郵送の場合は、実費をご負担いただきます。</li>
                    <li>支払方法：郵便定額小為替を申請書類に同封（無記名）<br />または同額分の切手</li>
                </ul>

                <h4>E. 開示等の求めに対する回答方法</h4>
                <p>申請者の申請書面記載宛に書面（eメール含む）によって回答いたします。書面以外での方法による回答をご希望される方は、手続き時にその旨ご連絡ください。</p>

                <h4>F. 非開示事由について</h4>
                <p>以下の(1)～(7)に該当する場合は、非開示とさせていただきます。非開示を決定した場合は、その旨、理由を付記して通知いたします。</p>
                <ul>
                    <li>(1)申請書・本人確認書類・登録情報の住所が一致しない等、本人確認ができない場合</li>
                    <li>(2)代理人による申請に際して代理権が確認できない場合</li>
                    <li>(3)所定の申請書類に不備があった場合</li>
                    <li>(4)開示対象個人情報に該当しない場合</li>
                    <li>(5)本人または第三者の生命・身体・財産等の権利利益を害するおそれがある場合</li>
                    <li>(6)当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
                    <li>(7)他の法令に違反することとなる場合</li>
                </ul>
                <h3>5. 苦情及び相談窓口</h3>
                <p>
                    当社は、ご提出いただいた個人情報に関する苦情、相談、及びその他のお問い合わせに、適切、かつ迅速に対応致します。
                    ご提出いただいた個人情報に関する苦情、相談は、電話又は電子メールにて下記までお申し付けください。
                </p>
                <ul>
                    <li>■電話による場合：TEL:0570-200-223</li>
                    <li>株式会社富士山マガジンサービス　個人情報問い合わせ係</li>
                    <li>受付時間：10:00～17:00（土、日、祝、年末年始休業）</li>
                    <li>■電子メールによる場合：e-mail：cs@fujisan.co.jp</li>
                </ul>

                <h3>6. 認定個人情報保護団体の名称及び、苦情の解決の申出先</h3>
                <p>
                    認定個人情報保護団体の名称：一般財団法人日本情報経済社会推進協会<br>
                    苦情の解決の申出先：認定個人情報保護団体事務局
                </p>
                <ul>
                    <li>住所：〒106-0032　東京都港区六本木1-9-9　六本木ファーストビル内</li>
                    <li>電話番号：03-5860-7565、0120-700-779</li>
                    <li>※当社の商品・サービスに関する問合せ先ではございません</li>
                </ul>
                <h3>7. 個人関連情報をパーソナルデータとして取得することについて</h3>

                <h4>（1）パーソナルデータとは</h4>
                <p>
                    パーソナルデータとは、インターネットやウェブサイト上で接続している端末やブラウザー等を判別するためのクッキー（Cookie）情報、
                    ウェブビーコン、IPアドレスの取得情報をいいます。個人情報には該当しませんが、個人に関係する情報（特定の個人を識別できない情報）です。
                </p>

                <section>
                    <h5>クッキー（Cookie）について</h5>
                    <p>
                        クッキー（Cookie）とは、ウェブサイト側のサーバーから、お客様側のウェブブラウザに対して送信される英数字からなる情報を、
                        お客様のコンピュータ（またはスマートフォン、タブレットなどのインターネットへ接続可能な機器）内に記憶させておく機能です。
                        アクセス情報の集計のほか、お客様ごとに遷移される画面の流れを制御する、メッセージを変更して表示する等の
                        サイトサービスのためにも使用されます。これによって、例えば、お客様が再度ウェブサイトを訪れた際、
                        お客様を識別して、ログインのために必要なIDやパスワード等の設定状況等を自動で再現することが可能になります。
                        クッキーを無効にされますと、当社のサービスを一部または全部ご利用いただくことができませんので、
                        あらかじめご了承下さい。
                    </p>
                </section>

                <section>
                    <h5>ウェブビーコンについて</h5>
                    <p>
                        ウェブビーコンとは、ウェブページや電子メールに埋め込まれた小さな画像ファイルです。
                        お客様が閲覧するページや、受信する広告メールの中には、ウェブビーコンを使用してアクセス状況を調べているものがあり、
                        ウェブサイト側で訪問の有無や訪問回数等のデータを把握することができます。
                    </p>
                </section>

                <section>
                    <h5>アクセス情報（ログ）について</h5>
                    <p>
                        ウェブサーバーは、サイトへのアクセス状況を記録するためにアクセスログを取得しています。
                        お客様が検索したページや、閲覧した商品の行動履歴等のアクセスログには、
                        お客様のIPアドレス、ブラウザー情報、プロバイダ情報、参照ページ、コンピュータ情報、アクセス時間等が含まれます。
                    </p>
                </section>

                <h4>（2） ウェブサイトでの情報の取扱いについて（行動履歴等）</h4>
                <section>
                    <h5>ア. 利用目的</h5>
                    <p>当社は、お客様からパーソナルデータを取得し、下記のために利用します。</p>
                    <ul>
                        <li>商品、サービス、ウェブサイトなどの内容をお客さまによりご満足いただけるよう改善するため。</li>
                        <li>商品、サービス、ウェブサイトなどの内容をお客さまに合わせてカスタマイズするため。</li>
                        <li>新しい商品、サービス、ウェブサイトを提供するため。</li>
                        <li>最適な販売促進を実施するための広告活動のため。</li>
                    </ul>
                </section>

                <section>
                    <h5>イ. 第三者からの取得</h5>
                    <p>当社は、当社の取引先よりパーソナルデータを取得し、お客様情報と紐づけたうえで、当社および当社グループ会社のマーケティング活動、お客様に最適な販売促進を実施するための広告活動のために利用します。</p>
                </section>

                <section>
                    <h5>ウ. 第三者サービスの利用</h5>
                    <p>当社では、第三者が提供する訪問者分析のためのサービスの利用および広告の配信をするために、当該第三者のクッキーも発信する場合があります。また、当社では統計や広告の効果測定のために、メールに記載されたURL等をユーザーがクリックしたことによりユーザーの行動履歴を取得したり、画像データに同様の仕組みを持たせることにより開封履歴を取得することがあります。</p>
                </section>

                <h4>（3） 当社で利用する主な広告配信サービス</h4>
                <p>当社が利用する主な広告サービスは次の通りであり、外部事業者の名称、外部事業者に送信される利用者情報の内容、サービス名等は以下の通りで、広告配信の目的で提供されます。各サービスで取得される情報は、単体では特定の個人を識別できない情報で、取得された情報の管理は、当社においては当社、各社においてはそれぞれ各社のプライバシーポリシーに基づき管理されます。広告配信等が不要な場合には、各社のサービスごとにオプトアウトすることができます。
                </p>

                <h5>■ヤフー株式会社</h5>
                <p>送信される利用者情報：</p>
                <ul>
                    <li>Yahoo! JAPAN が利用者を特定するための識別子</li>
                    <li>クッキーなどデバイスに記録されている識別子</li>
                    <li>IPアドレス（位置情報や回線種別、アクセス元の企業や組織の推定に用いられます。）</li>
                    <li>閲覧したサイトのURLやアプリの画面名</li>
                    <li>閲覧したサイトやアプリのタイトル</li>
                    <li>当社訪問の直前に閲覧したサイトのURL</li>
                    <li>閲覧日時（滞在時間などの算出に用いられます。）</li>
                    <li>ウェブブラウザやデバイスの種類、バージョン</li>
                    <li>デバイスの画面サイズ等の閲覧環境の情報</li>
                </ul>
                <p>サービス名：Yahoo! 広告</p>
                <ul>
                    <li>Yahoo! JAPANが提供するサービスのプライバシーポリシー／Yahoo! JAPAN広告からのオプトアウト／クッキーポリシー</li>
                </ul>

                <h5>■Google LLC</h5>
                <p>送信される利用者情報：</p>
                <ul>
                    <li>クッキーなどデバイスに記録されている識別子</li>
                    <li>IPアドレス（位置情報や回線種別、アクセス元の企業や組織の推定に用いられます。）</li>
                    <li>閲覧したサイトのURLやアプリの画面名</li>
                    <li>閲覧したサイトやアプリのタイトル</li>
                    <li>当社訪問の直前に閲覧したサイトのURL</li>
                    <li>閲覧日時（滞在時間などの算出に用いられます。）</li>
                    <li>ウェブブラウザやデバイスの種類、バージョン</li>
                    <li>デバイスの画面サイズ等の閲覧環境の情報</li>
                </ul>
                <p>サービス名：Google広告</p>
                <ul>
                    <li>Googleが提供するサービスのプライバシーポリシー／Google広告からのオプトアウト／クッキーポリシー</li>
                </ul>

                <h5>■Criteo 株式会社</h5>
                <p>送信される利用者情報：</p>
                <ul>
                    <li>クッキーなどデバイスに記録されている識別子</li>
                    <li>IPアドレス（位置情報や回線種別、アクセス元の企業や組織の推定に用いられます。）</li>
                    <li>閲覧したサイトのURLやアプリの画面名</li>
                    <li>閲覧したサイトやアプリのタイトル</li>
                    <li>当社訪問の直前に閲覧したサイトのURL</li>
                    <li>閲覧日時（滞在時間などの算出に用いられます。）</li>
                    <li>ウェブブラウザやデバイスの種類、バージョン</li>
                    <li>デバイスの画面サイズ等の閲覧環境の情報</li>
                </ul>
                <p>サービス名：Criteo</p>
                <ul>
                    <li>Criteoが提供するサービスのプライバシーポリシー／Criteo広告からのオプトアウト</li>
                </ul>

                <h4>（4） 当社で利用する主なウェブサイトアクセス情報の収集・分析サービス</h4>
                <p>当社は、クッキー等の技術を利用し、ウェブサイトを閲覧したユーザーのアクセス情報を統計的に収集・分析することができるサービスを利用しており、外部事業者の名称、外部事業者に送信される利用者情報の内容、サービス名等は以下の通りです。収集した情報は当社の事業におけるサービス改善のための分析や広告配信などに利用します。なお、このアクセスに関する情報は匿名で収集されており、個人を特定するものではありません。
                </p>

                <h5>■Google LLC</h5>
                <p>送信される利用者情報：</p>
                <ul>
                    <li>クッキーなどデバイスに記録されている識別子</li>
                    <li>IPアドレス（位置情報や回線種別、アクセス元の企業や組織の推定に用いられます。）</li>
                    <li>閲覧したサイトのURLやアプリの画面名</li>
                    <li>閲覧日時（滞在時間などの算出に用いられます。）</li>
                    <li>ウェブブラウザやデバイスの種類、バージョン</li>
                    <li>デバイスの画面サイズ等の閲覧環境の情報</li>
                </ul>
                <p>サービス名：Google Analytics</p>
                <ul>
                    <li>Googleが提供するサービスでのクッキーによる情報収集や情報の取り扱いについて／Googleが提供するサービスのプライバシーポリシー／Google
                        Analyticsからのオプトアウト／GoogleによるCookieの利用方法</li>
                </ul>

                <h5>■Microsoft Corporation</h5>
                <p>送信される利用者情報：</p>
                <ul>
                    <li>クッキーなどデバイスに記録されている識別子</li>
                    <li>マウスの操作や画面タップなどの画面操作情報</li>
                    <li>IPアドレス（位置情報や回線種別、アクセス元の企業や組織の推定に用いられます。）</li>
                    <li>ウェブブラウザやデバイスの種類、バージョン</li>
                    <li>デバイスの画面サイズ等の閲覧環境の情報</li>
                </ul>
                <p>サービス名：Clarity</p>
                <ul>
                    <li>Microsoft Clarity –Terms of Use／Microsoft プライバシーステートメント</li>
                </ul>

                <h4>（5）当社で利用するSNS</h4>
                <p>当社は、以下の情報（以下「お客様情報」といいます）を取得またはLINE株式会社から提供を受ける可能性があります。</p>
                <h5>■LINEヤフー株式会社</h5>
                <p>取得する利用者情報：</p>
                <ul>
                    <li>LINEヤフー株式会社がLINEユーザーを識別するための情報、コミュニケーションの中で得たお客様に関する情報（お客様が閲覧したURLに付与されたパラメータ情報を含みます。）</li>
                    <li>本LINE公式アカウントを経由して遷移した外部サイト上で取得した情報（当該外部サイト上での購入可否を含めたトラッキング情報を含みます）</li>
                </ul>
                <p>＜お客様情報のLINEプラットフォーム上での共通利用について＞</p>
                <p>当社がLINEプラットフォーム上で提供する以下の各サービスにおいて、お客様情報を共通で利用させていただく場合があります。</p>
                <ul>
                    <li>当社が提供するLINE公式アカウント（当社の企業アカウントをいいます）</li>
                    <li>LINEログイン、LINEミニアプリ等、LINEプラットフォーム上で当社が提供するサービス</li>
                </ul>
                <p>サービス名：LINE</p>
                <ul>
                    <li>LINEヤフープライバシーポリシー｜LINEヤフー株式会社</li>
                </ul>
                <h4>（6） 管理方法</h4>
                <p>
                    お客様は、(3)で記載の各サービスにおけるオプトアウト措置を利用するほか、
                    ご使用のウェブブラウザで全てまたは一部のクッキー等を拒否するように設定することができます。
                </p>
                <p>
                    クッキー等の設定に関する具体的な方法については、ウェブブラウザのヘルプメニュー等をご確認ください。
                    なお、クッキー等を拒否された場合は、当社サービスのご利用ができない場合があります。
                </p>
                <h4>8．個人情報の突合による広告配信等について</h4>
                <p>
                    当社は、第三者（当社と契約を締結した提携会社）から受託したお客様の個人情報を、当社が管理するお客様の個人情報と突合・分析して利用します。
                    <br />
                    例えば、お客様に関する広告識別子、メールアドレス、電話番号等の個人情報を第三者より受託し、当社が管理する広告識別子等およびその他の個人情報と突合・分析することで、よりお客様にカスタマイズした広告配信が行えるようになります。
                    <br />
                    また、第三者から受託したお客様の個人情報を当社が管理するお客様の個人情報と突合・分析し、当該第三者によるマーケティングやサービス改善・開発等の目的のために、お客様個人を特定できないような形式の情報に加工したうえで、当該第三者に提供することがあります。
                    <br />
                    また、当社は、当社が管理するお客様の個人情報を、広告配信等の目的で、第三者（私たちと契約を締結した広告配信サービス等を提供する提携会社）に提供することがあります。
                    <br />
                    例えば、当社が管理する広告識別子、メールアドレス、電話番号等の個人情報を、お客様に対する広告配信目的で当該第三者に提供し、当該第三者が管理する広告識別子等およびその他の個人情報または個人関連情報と突合・分析することで、よりお客様にカスタマイズした広告配信が行えるようになります。
                    <br />
                    この場合、当該第三者は、当社から依頼された広告配信のために、お客様の個人情報を利用します。
                    <br />
                    なお、当社は、当社が管理するお客様の広告識別子等の個人情報を、広告成果の確認やポイントの付与等の目的で、広告出稿者（広告主）を含む第三者に提供し、当該第三者は、自ら管理する広告識別子等およびその他の個人情報または個人関連情報と紐づけて、条件達成情報等とともに当社に提供することがあります。
                    <br />
                    当社は、当該提供を受けた情報を私たちが管理する個人情報と紐づけることで、お客様の広告成果の確認やポイントの付与等のために利用します。
                </p>

                <h4>9．個人関連情報を個人データとして取得することについて</h4>
                <p>
                    当社は、氏名等のお客様を特定する情報を保有しない第三者から、識別子や行動履歴など、お客様に関連する情報（個人関連情報）の提供を受け、当該情報を私たちが管理するお客様の個人情報と紐づけることで個人情報として取得し、別途の目的が示されている場合を除き、上記「2.
                    利用目的」でご説明した目的にしたがって、当該情報を利用することがあります。<br>
                    具体的には、Cookie等、モバイル広告識別子、メールアドレスや電話番号（不可逆的な変換処理がなされたものを含みます。）、広告の閲覧回数等の広告配信関連ログ、ウェブサイトの閲覧履歴や検索履歴、実店舗でのショッピングを含む購買履歴、位置情報その他の行動履歴、TV視聴関連ログ等を取得し、当社が管理する個人情報と紐づけて利用する場合があります。この場合は、適用法令に従い、個人情報として適切に取り扱います。
                </p>

                <h4>顧客個人情報の取扱いに関する同意文</h4>
                <p>当社サイトをご利用いただく際には、以下の顧客個人情報の取扱いに関して同意いただくことになります。</p>

                <h5>１．顧客個人情報の利用目的</h5>
                <p>顧客個人情報の利用目的は、以下のとおりです。</p>

                <table border="1">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>個人情報の種類</th>
                            <th>利用目的</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>当社の定期購読サービス等をご利用の方の個人情報</td>
                            <td>
                                購入商品の配送のため<br>
                                商品代金回収のため<br>
                                ｅメール等による商品、サービス、キャンペーン等の広告の案内のため<br>
                                個人が特定できない形で取得した閲覧履歴や購買履歴等の情報を分析して、趣味・嗜好に<br>
                                応じた新商品・サービスに関する広告のため
                            </td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>当社にお問合わせいただいた方の個人情報</td>
                            <td>お問い合わせ対応、トラブル対処、オペレーター教育など応対品質向上のため</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>当社カスタマーQ＆Aサービス利用者</td>
                            <td>
                                カスタマーQ＆Aサイトの投稿内容の確認のため<br>
                                ｅメール等によるカスタマーQ＆Aサイトのサービス内容のご案内のため<br>
                                ｅメール等による商品、サービス、キャンペーン等の広告に関するご案内のため
                            </td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>採用応募者の方の個人情報</td>
                            <td>採用選考、ご連絡のため</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>当社の従業者の個人情報</td>
                            <td>人事、総務などの雇用管理等のため</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>パートナー（提携企業）からの委託により当社の定期購読サービス等をご利用の方の個人情報</td>
                            <td>
                                購入商品配送のため<br>
                                提携企業及びお客様がご購入された商品の発売元企業からのｅメール等による商品、<br>
                                サービス、キャンペーン等の広告に関するご案内のため
                            </td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>SNS公式アカウントに登録された方の個人情報</td>
                            <td>
                                当社のサービス利用状況の把握およびその分析のため<br>
                                お問い合わせ対応、トラブル対処、オペレーター教育など応対品質向上のため<br>
                                その他当社のプライバシーポリシー等にて公表する利用目的達成のため
                            </td>
                        </tr>
                    </tbody>
                </table>

                <p>
                    ※上記の利用目的のうちNo.1～4については保有個人データ（開示対象個人情報）の利用目的であり、下記4.の開示等のご請求に対応させていただきます。<br>
                    なお、6、7については、パートナー（提携企業）様又は各SNS運営会社様にご請求いただきますようお願い致します。
                </p>

                <h5>２．顧客個人情報の提供</h5>
                <p>
                    今回ご収集させていただく「個人情報」は、以下の理由で第三者に提供させていただきます。<br>
                    (1) 提供先：お客様が購入した商品の発売元企業、警察、警備会社<br>
                    (2) 提供の目的：購入商品配送のため、各種サービスの案内のため、施設管理及び保安上の目的のため<br>
                    (3)
                    提供する個人情報の項目：郵便番号、住所、氏名、電話番号、メールアドレス、購入商品名、期間、ビデオカメラによる映像、音声データ、個人を特定できない形でのユーザーが閲覧したページや広告の履歴、検索キーワード、利用時間帯、ウェブサイトの利用方法、利用環境（利用に際しての各種設定情報なども含む）、ユーザーのIPアドレスおよびそれに割り当てられた組織名、第三者企業が発行する匿名ID、アプリ内ユニークID、位置情報、Cookie情報<br>
                    (4) 提供の手段又は方法：提供先による該当情報のファイルダウンロード、映像、音声データファイルの提供<br>
                    (5) 個人情報の取扱いに関する契約の有無：無
                </p>

                <h5>３．顧客個人情報の外部委託</h5>
                <p>
                    今回取得させていただく顧客個人情報は、以下の業務処理のため、当社と契約を締結している協力会社に委託させていただきます。<br>
                    (1)委託先：1.倉庫会社、運送会社等　2.決済代行会社　3.広告配信代行会社<br>
                    (2)委託処理の内容：1.購入商品配送のため　2.決済代行業務のため　3.広告配信業務のため
                </p>

                <h5>４．取得させていただく内容について</h5>
                <p>
                    今回取得させていただく顧客個人情報のうち、必須項目は以下のとおりです。<br>
                    個人顧客の場合：郵便番号、住所、氏名、電話番号、生年月日、性別、メールアドレス、パスワード、電話応対による音声データ、個人を特定できない形でのユーザーが閲覧したページや広告の履歴、検索キーワード、利用時間帯、ウェブサイトの利用方法、利用環境（利用に際しての各種設定情報なども含む）、ユーザーのIPアドレスおよびそれに割り当てられた組織名、第三者企業が発行する匿名ID、アプリ内ユニークID、位置情報、Cookie情報<br>
                    法人顧客の場合：郵便番号、住所、会社名、氏名、電話番号、担当者名、メールアドレス、パスワード、電話応対による音声データ、個人を特定できない形でのユーザーが閲覧したページや広告の履歴、検索キーワード、利用時間帯、ウェブサイトの利用方法、利用環境（利用に際しての各種設定情報なども含む）、ユーザーのIPアドレスおよびそれに割り当てられた組織名、第三者企業が発行する匿名ID、アプリ内ユニークID、位置情報、Cookie情報<br>
                    来訪顧客の場合：映像、音声データ<br>
                    上記項目および上記項目以外の個人情報を入力しなかった場合、サービスのご提供ができないことがございます。
                </p>

                <h5>５．顧客個人情報に関する開示・訂正・削除について</h5>
                <p>
                    今回収集させていただく顧客個人情報に関して開示するよう請求することができます。また万一登録内容が不正確または誤りであることが判明した場合には、当社は速やかに訂正または削除に応じさせていただきます。<br>
                    当社が当該情報を利用、提供している場合であっても、申込者から中止の申し出があった場合は、それ以降当社での利用、他者への提供を中止する措置をとります。<br>
                    ご自身の個人情報は「マイページ」にログインしていただくことで、訂正、追加、変更を行っていただくことが出来ます。<br>
                    個人情報の開示・削除のお問合せや、利用・提供中止の申出等に関しましては、以下にご連絡ください。<br>
                    株式会社富士山マガジンサービス カスタマーサポート係<br>
                    TEL：0570-200-223 FAX：03-5459-7073<br>
                    e-mail：cs@fujisan.co.jp
                </p>
                <p>
                    また、利用者は、個人を特定しない形での履歴情報および特性情報の利用を拒否することができます。第三者企業が発行するCookie及び匿名ID・アプリ内ユニークIDについて、Cookie及び匿名ID・アプリ内ユニークIDを無効にしたい場合の手続きについては、下記にご案内したページ等をご確認下さい。
                </p>
                <p>■ヤフー株式会社</p>
                <p>サービス名：Yahoo! 広告</p>
                <ul>
                    <li>Yahoo! JAPANが提供するサービスのプライバシーポリシー</li>
                    <li>Yahoo! JAPAN広告からのオプトアウト</li>
                    <li>クッキーポリシー</li>
                </ul>
                <p>■Google LLC</p>
                <p>サービス名：Google広告</p>
                <ul>
                    <li>Googleが提供するサービスのプライバシーポリシー</li>
                    <li>Google広告からのオプトアウト</li>
                    <li>クッキーポリシー</li>
                </ul>
                <p>■Criteo 株式会社</p>
                <p>サービス名：Criteo</p>
                <ul>
                    <li>Criteoが提供するサービスのプライバシーポリシー</li>
                    <li>Criteo広告からのオプトアウト</li>
                </ul>
                <p>■Microsoft Corporation</p>
                <p>サービス名：Clarity</p>
                <ul>
                    <li>Microsoft Clarity –Terms of Use</li>
                    <li>Microsoft プライバシーステートメント</li>
                </ul>
                <p>■LINEヤフー株式会社</p>
                <p>サービス名：LINE</p>
                <ul>
                    <li>LINEヤフープライバシーポリシー｜LINEヤフー株式会社</li>
                </ul>
                <h5>６．当社の個人情報保護管理者</h5>
                <ul>
                    <li>氏名：前田 嘉也</li>
                    <li>職名：経営管理グループディレクター</li>
                    <li>TEL：0570-200-223</li>
                </ul>
            </section>
        </article>
        `;
}
